import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=5d0c06f7&scoped=true&lang=html&"
import script from "./Player.vue?vue&type=script&lang=js&"
export * from "./Player.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0c06f7",
  null
  
)

export default component.exports